/* eslint-disable react-refresh/only-export-components */
import React, { createContext, useContext, useState } from 'react';
import type { ReactNode } from 'react';

interface CheckoutDialogContextType {
  isCheckoutDialogOpen: boolean;
  setIsCheckoutDialogOpen: (isOpen: boolean) => void;
}

const CheckoutDialogContext = createContext<CheckoutDialogContextType | undefined>(undefined);

export const useCheckoutDialog = () => {
  const context = useContext(CheckoutDialogContext);
  if (context === undefined) {
    throw new Error('useCheckoutDialog must be used within a CheckoutDialogProvider');
  }
  return context;
};

interface CheckoutDialogProviderProps {
  children: ReactNode;
}

export const CheckoutDialogProvider: React.FC<CheckoutDialogProviderProps> = ({ children }) => {
  const [isCheckoutDialogOpen, setIsCheckoutDialogOpen] = useState(false);

  return (
    <CheckoutDialogContext.Provider
      value={{
        isCheckoutDialogOpen,
        setIsCheckoutDialogOpen,
      }}
    >
      {children}
    </CheckoutDialogContext.Provider>
  );
};
